export var PaymentType;
(function(PaymentType2) {
  PaymentType2["CHARITY"] = "Charity";
  PaymentType2["STRIPE"] = "Stripe";
  PaymentType2["SENDDOTS"] = "SendDots";
})(PaymentType || (PaymentType = {}));
export var Statuses;
(function(Statuses2) {
  Statuses2["ACTIVE"] = "1";
  Statuses2["INACTIVE"] = "0";
  Statuses2["ARCHIVED"] = "-1";
  Statuses2["QUARANTINED"] = "-2";
  Statuses2["DISABLED"] = "-3";
})(Statuses || (Statuses = {}));
export var EeoOptions;
(function(EeoOptions2) {
  EeoOptions2[EeoOptions2["yes"] = 1] = "yes";
  EeoOptions2[EeoOptions2["no"] = 0] = "no";
  EeoOptions2[EeoOptions2["no_answer"] = -1] = "no_answer";
})(EeoOptions || (EeoOptions = {}));
export var ECallLogTypes;
(function(ECallLogTypes2) {
  ECallLogTypes2["PARTICIPANT_JOIN"] = "PARTICIPANT_JOIN";
  ECallLogTypes2["PARTICIPANT_DISCONNECT"] = "PARTICIPANT_DISCONNECT";
  ECallLogTypes2["PARTICIPANT_IN_PROGRESS"] = "PARTICIPANT_IN_PROGRESS";
  ECallLogTypes2["CONNECT_ERROR"] = "CONNECT_ERROR";
})(ECallLogTypes || (ECallLogTypes = {}));
export var FieldTargetType;
(function(FieldTargetType2) {
  FieldTargetType2["members"] = "ask_members";
  FieldTargetType2["experts"] = "ask_experts";
  FieldTargetType2["onboarding"] = "ask_during_onboarding";
})(FieldTargetType || (FieldTargetType = {}));
export var FieldType;
(function(FieldType2) {
  FieldType2["text"] = "text";
  FieldType2["radio"] = "radio";
  FieldType2["number"] = "number";
  FieldType2["select"] = "select";
  FieldType2["wysiwyg"] = "wysiwyg";
  FieldType2["checkbox"] = "checkbox";
  FieldType2["label"] = "label";
  FieldType2["multiCheckbox"] = "multiCheckbox";
  FieldType2["multiSelect"] = "multiSelect";
})(FieldType || (FieldType = {}));
export var SubscriptionKind;
(function(SubscriptionKind2) {
  SubscriptionKind2["single"] = "single";
  SubscriptionKind2["monthly"] = "monthly";
  SubscriptionKind2["overage"] = "overage";
})(SubscriptionKind || (SubscriptionKind = {}));
var PaymentMethodType;
(function(PaymentMethodType2) {
  PaymentMethodType2["Card"] = "card";
})(PaymentMethodType || (PaymentMethodType = {}));
export var IntegrationTypes;
(function(IntegrationTypes2) {
  IntegrationTypes2["embed"] = "embed";
  IntegrationTypes2["top_level"] = "top_level";
})(IntegrationTypes || (IntegrationTypes = {}));
export var IdentityProviders;
(function(IdentityProviders2) {
  IdentityProviders2["GOOGLE"] = "Google";
  IdentityProviders2["LINKED_IN"] = "LinkedIn";
  IdentityProviders2["EMAIL"] = "Email";
})(IdentityProviders || (IdentityProviders = {}));
